import { useState, useEffect } from 'react';

export type Viewport = 'mobile' | 'tablet' | 'desktop';

interface ViewportBreakpoints {
  mobile: { max: number };
  tablet: { min: number; max: number };
  desktop: { min: number };
}

const BREAKPOINTS: ViewportBreakpoints = {
  mobile: { max: 639 },
  tablet: { min: 640, max: 1023 },
  desktop: { min: 1024 },
};

export function useViewport(): Viewport {
  const [viewport, setViewport] = useState<Viewport>('desktop');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= BREAKPOINTS.mobile.max) {
        setViewport('mobile');
      } else if (width >= BREAKPOINTS.tablet.min && width <= BREAKPOINTS.tablet.max) {
        setViewport('tablet');
      } else {
        setViewport('desktop');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return viewport;
}
